import { render, staticRenderFns } from "./viewloanrequests.vue?vue&type=template&id=7f6126af&scoped=true"
import script from "./viewloanrequests.vue?vue&type=script&lang=js"
export * from "./viewloanrequests.vue?vue&type=script&lang=js"
import style0 from "./viewloanrequests.vue?vue&type=style&index=0&id=7f6126af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6126af",
  null
  
)

export default component.exports